import { useQuery } from "@tanstack/react-query";
import { vocabService } from "../services/vocabService";

export const useWordInstructionAudio = (wordNumber) => {
  return useQuery({
    queryKey: ["wordInstructionAudio", wordNumber],
    queryFn: () => vocabService.getWordInstructionAudio(wordNumber),
    staleTime: Infinity,
    cacheTime: Infinity
  });
};

export const useSentenceInstructionAudio = (sentenceNumber) => {
  return useQuery({
    queryKey: ["sentenceInstructionAudio", sentenceNumber],
    queryFn: () => vocabService.getSentenceInstructionAudio(sentenceNumber),
    staleTime: Infinity,
    cacheTime: Infinity
  });
};
